import { ParseKeys } from "i18next";
import { QuoteApprovalStatus } from "generated/graphql";

export type LeadTab =
  | "all"
  | "starred"
  | "unprocessed"
  | "completed"
  | "archived";

export const LEAD_TABS: { label: ParseKeys<"leads">; path: LeadTab }[] = [
  { label: "tabs.all", path: "all" },
  { label: "tabs.starred", path: "starred" },
  { label: "tabs.unprocessed", path: "unprocessed" },
  { label: "tabs.completed", path: "completed" },
  { label: "tabs.archived", path: "archived" },
];

export const EMPTY_TAB_TEXT: Record<LeadTab, ParseKeys<"leads">> = {
  all: "empty.all",
  starred: "empty.starred",
  unprocessed: "empty.unprocessed",
  completed: "empty.completed",
  archived: "empty.archived",
};

interface TabbedLead {
  starred: boolean;
  archived: boolean;
  viewed: boolean;
  approvalStatus: QuoteApprovalStatus;
}

/**
 * Whether a lead belongs on a tab. Archived leads only show under Archived;
 * "unprocessed" means never opened, "completed" means the customer approved.
 */
export const isOnTab = (lead: TabbedLead, tab: LeadTab): boolean => {
  if (tab === "archived") {
    return lead.archived;
  }
  if (lead.archived) {
    return false;
  }

  switch (tab) {
    case "starred":
      return lead.starred;
    case "unprocessed":
      return !lead.viewed;
    case "completed":
      return lead.approvalStatus === QuoteApprovalStatus.Approved;
    default:
      return true;
  }
};

export const isLeadTab = (tab: string): tab is LeadTab =>
  LEAD_TABS.some(({ path }) => path === tab);
